import { createContext, useContext, useEffect } from 'react'

export interface AnimationContextValue {
  shouldAnimate: boolean
  requireAnimation: () => void
  revokeAnimation: () => void
}

//TODO: 07.01. think if this is still neccessary as we have animations basically everywhere already
export const AnimationContext = createContext<AnimationContextValue | undefined>(undefined)

export function useAnimationContext() {
  const context = useContext(AnimationContext)
  if (!context) {
    throw new Error('animationContext must be used within AnimationProvider')
  }
  return context
}

export function useRegisterForAnimation() {
  const { requireAnimation, revokeAnimation } = useAnimationContext()

  useEffect(() => {
    requireAnimation()
    return () => revokeAnimation()
  }, [requireAnimation, revokeAnimation])
}